<div awairForm>
  <ng-container formHeader>
    <h2 awairFormTitle>Edit Devices Name</h2>
  </ng-container>

  <ng-container formBody>
    <awair-table class="__table" [columnHeaders]="tableColumnHeaders">
      <tr *ngFor="let device of devices; let i = index" awairTableBodyRow>
        <td awairTableBodyCell>{{i + 1}}</td>
        <td class="__column-name" awairTableBodyCell>
          <div class="__device-name-wrapper">
            <input class="__device-name"
                   type="text"
                   placeholder="Enter device name"
                   value="{{device.deviceName}}"
                   (focus)="onDeviceNameFocus($event, i)"
                   (blur)="onDeviceNameBlur($event)"
                   (input)="onDeviceNameChange(device.uuid, $event.target.value, i)"
                   [ngClass]="isDeviceNameEmpty[i] ? '__device-name--empty' : null"/>
            <awair-warning-icon class="__device-name-icon"
                                [ngClass]="isDeviceNameEmpty[i] ? '__device-name-icon--show' : '__device-name-icon--hide'">
            </awair-warning-icon>
            <awair-enter-icon class="__device-name-icon"
                              [ngClass]="(focusedDeviceIndex === i && !isDeviceNameEmpty[i]) ? '__device-name-icon--show' : '__device-name-icon--hide'">
            </awair-enter-icon>
          </div>
        </td>
        <td class="__column-owner" awairTableBodyCell>
          {{device.ownerFirstName}} {{device.ownerLastName}}
        </td>
        <td class="__column-email" awairTableBodyCell>
          {{device.email}}
        </td>
      </tr>
    </awair-table>
  </ng-container>

  <ng-container formFooter>
    <awair-confirm-button-pair [isDisabled]="!isChanged || isLoading || hasEmpty"
                               [isLoading]="isLoading"
                               (cancel)="onCancel()"
                               (confirm)="onSave()">
      <span cancelContents>Cancel</span>
      <span confirmContents>Save</span>
    </awair-confirm-button-pair>
  </ng-container>
</div>
